import { KOALA, GYPSUM } from 'HubStyleTokens/colors';
const defaultFileAttachmentTheme = {
  tileBackgroundColor: GYPSUM,
  tileBorderColor: KOALA
};
const FileAttachmentTheme = themeProps => Object.assign({}, defaultFileAttachmentTheme, themeProps);
export default FileAttachmentTheme;